import { z } from "zod";
import { senhaNovaSchema } from "./senha";

export const requestPasswordResetSchema = z.object({
  email: z.string().trim().toLowerCase().email("E-mail invalido"),
});

export type RequestPasswordResetInput = z.infer<typeof requestPasswordResetSchema>;

export const confirmPasswordResetSchema = z.object({
  token: z.string().min(1, "Token invalido"),
  newPassword: senhaNovaSchema,
});

export type ConfirmPasswordResetInput = z.infer<typeof confirmPasswordResetSchema>;
